<ng-container *ngIf="vm$ | async as vm">
	<ui-section title="Delete Custom Requisition Template" type="sub-section">
		<section section-content>
			<p>
				Are you sure you want to delete this requisition template? This action
				cannot be undone.
			</p>
		</section>
	</ui-section>

	<footer class="flex justify-end items-center gap-2 mt-auto pt-4">
		<ui-button label="Cancel" (click)="closeModal()" preset="MEDIUM_EMPHASIS" />
		<ui-button
			label="Delete"
			[loading]="vm.loading"
			[disabled]="vm.loading"
			(click)="onSubmit(customRequisition)"
		/>
	</footer>
</ng-container>
